// Illustrations SVG animées légères par type de séance / ambiance.
// Respecte prefers-reduced-motion via classes CSS déjà globales.

export default function SessionIllustration({ ambient = "pink", method = "breathing", size = 72 }) {
  const stroke = "#B2C5BC";
  const fillSoft = "rgba(178,197,188,0.35)";

  if (method === "breathing") {
    return (
      <svg width={size} height={size} viewBox="0 0 72 72" aria-hidden data-testid="illu-breathing">
        <defs>
          <radialGradient id="brG" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="rgba(178,197,188,0.55)" />
            <stop offset="70%" stopColor="rgba(136,160,150,0.15)" />
            <stop offset="100%" stopColor="rgba(0,0,0,0)" />
          </radialGradient>
        </defs>
        <circle cx="36" cy="36" r="22" fill="url(#brG)">
          <animate attributeName="r" values="18;28;18" dur="6s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.8;1;0.8" dur="6s" repeatCount="indefinite" />
        </circle>
        <circle cx="36" cy="36" r="10" fill={fillSoft} />
      </svg>
    );
  }

  if (method === "pmr") {
    return (
      <svg width={size} height={size} viewBox="0 0 72 72" aria-hidden data-testid="illu-pmr">
        {[8, 16, 24].map((r, i) => (
          <circle key={r} cx="36" cy="36" r={r} fill="none" stroke={stroke} strokeOpacity="0.5" strokeWidth="1.2">
            <animate attributeName="r" values={`${r};${r + 6};${r}`} dur="4s" begin={`${i * 0.6}s`} repeatCount="indefinite" />
            <animate attributeName="opacity" values="0.7;0.15;0.7" dur="4s" begin={`${i * 0.6}s`} repeatCount="indefinite" />
          </circle>
        ))}
        <circle cx="36" cy="36" r="3" fill={stroke} />
      </svg>
    );
  }

  if (method === "presence") {
    // Petits points flottants
    const dots = [
      { cx: 22, cy: 30, d: "0s" },
      { cx: 36, cy: 20, d: "0.8s" },
      { cx: 50, cy: 32, d: "1.4s" },
      { cx: 30, cy: 46, d: "2.0s" },
      { cx: 46, cy: 50, d: "0.4s" },
    ];
    return (
      <svg width={size} height={size} viewBox="0 0 72 72" aria-hidden data-testid="illu-presence">
        {dots.map((p) => (
          <circle key={p.cx + "-" + p.cy} cx={p.cx} cy={p.cy} r="3" fill={stroke} opacity="0.7">
            <animate attributeName="cy" values={`${p.cy};${p.cy - 4};${p.cy}`} dur="4s" begin={p.d} repeatCount="indefinite" />
            <animate attributeName="opacity" values="0.3;0.9;0.3" dur="4s" begin={p.d} repeatCount="indefinite" />
          </circle>
        ))}
      </svg>
    );
  }

  // Fallback ambiance
  if (ambient === "rain") {
    return (
      <svg width={size} height={size} viewBox="0 0 72 72" aria-hidden data-testid="illu-rain">
        {[16, 30, 44, 56].map((x, i) => (
          <line key={x} x1={x} y1="10" x2={x - 3} y2="22" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" opacity="0.6">
            <animate attributeName="y1" values="10;46;10" dur="1.8s" begin={`${i * 0.3}s`} repeatCount="indefinite" />
            <animate attributeName="y2" values="22;58;22" dur="1.8s" begin={`${i * 0.3}s`} repeatCount="indefinite" />
            <animate attributeName="opacity" values="0.1;0.9;0.1" dur="1.8s" begin={`${i * 0.3}s`} repeatCount="indefinite" />
          </line>
        ))}
      </svg>
    );
  }

  if (ambient === "ocean") {
    return (
      <svg width={size} height={size} viewBox="0 0 72 72" aria-hidden data-testid="illu-ocean">
        <path d="M4 42 Q18 32 32 42 T60 42 T90 42" fill="none" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" opacity="0.7">
          <animate attributeName="d" values="M4 42 Q18 32 32 42 T60 42 T90 42;M4 42 Q18 50 32 42 T60 42 T90 42;M4 42 Q18 32 32 42 T60 42 T90 42" dur="5s" repeatCount="indefinite" />
        </path>
        <path d="M4 52 Q18 44 32 52 T60 52 T90 52" fill="none" stroke={stroke} strokeWidth="1.4" strokeLinecap="round" opacity="0.45">
          <animate attributeName="d" values="M4 52 Q18 60 32 52 T60 52 T90 52;M4 52 Q18 44 32 52 T60 52 T90 52;M4 52 Q18 60 32 52 T60 52 T90 52" dur="6s" repeatCount="indefinite" />
        </path>
      </svg>
    );
  }

  // pink / brown noise — souffle horizontal
  return (
    <svg width={size} height={size} viewBox="0 0 72 72" aria-hidden data-testid={`illu-${ambient}`}>
      {[24, 32, 40, 48].map((y, i) => (
        <line key={y} x1="8" y1={y} x2="64" y2={y} stroke={stroke} strokeWidth="1.2" strokeLinecap="round" opacity="0.5">
          <animate attributeName="opacity" values="0.15;0.75;0.15" dur="4s" begin={`${i * 0.5}s`} repeatCount="indefinite" />
          <animate attributeName="x1" values="8;14;8" dur="4s" begin={`${i * 0.5}s`} repeatCount="indefinite" />
          <animate attributeName="x2" values="64;58;64" dur="4s" begin={`${i * 0.5}s`} repeatCount="indefinite" />
        </line>
      ))}
    </svg>
  );
}
